/* eslint-disable @typescript-eslint/naming-convention */
import { AnalyticsContextValue } from "@swiggy-private/checkout-core";
import { SCREEN_NAME, IMPRESSION_ACTIONS, CLICK_ACTIONS } from "../constants";
import { DEAL_RUSH_GROUP_TAG_ID } from "@cart-client/constants/index";

type ContextData = { headerString?: string; subHeadString?: string; couponType?: string };

type DelightPopupContextData = {
    category?: {
        PH?: string;
        offer_applied?: string;
    };
    cardType?: string;
};

const buildDelightPopupContext = (isPHCallout = false, isDealRush = false, cardType = ""): string | undefined => {
    const contextData: DelightPopupContextData = {};
    contextData.cardType = cardType;
    if (isPHCallout) {
        contextData.category = { ...contextData.category, PH: "true" };
    }

    if (isDealRush) {
        contextData.category = { ...contextData.category, offer_applied: DEAL_RUSH_GROUP_TAG_ID };
    }

    return Object.keys(contextData).length > 0 ? JSON.stringify(contextData) : undefined;
};

export const impressionAutoApplyCouponPopupEvent = (
    impressionEvent: AnalyticsContextValue["impressionEvent"],
): void => {
    impressionEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: IMPRESSION_ACTIONS.IMPRESSION_AUTO_APPLIED_COUPON_POPUP,
    });
};

export const impressionOffercashSuccessPopupEvent = (
    impressionEvent: AnalyticsContextValue["impressionEvent"],
    isPHCallout = false,
): void => {
    impressionEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: IMPRESSION_ACTIONS.IMPRESSION_OFFERCASH_COUPON_SUCCESS_POPUP,
        context: (isPHCallout && JSON.stringify({ category: { PH: "true" } })) || undefined,
    });
};

export const impressionDelightPopupEvent = (
    impressionEvent: AnalyticsContextValue["impressionEvent"],
    isPHCallout = false,
    isDealRush = false,
    cardType = "",
): void => {
    impressionEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: IMPRESSION_ACTIONS.IMPRESSION_OFFERCASH_DELIGHT_POPUP,
        context: buildDelightPopupContext(isPHCallout, isDealRush, cardType),
    });
};

export const clickCloseDelightPopupEvent = (
    clickEvent: AnalyticsContextValue["clickEvent"],
    isDealRush = false,
    cardType = "",
): void => {
    clickEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: CLICK_ACTIONS.CLICK_CLOSE_DELIGHT_POPUP,
        context: buildDelightPopupContext(false, isDealRush, cardType),
    });
};

export const impressionMoreOffersStrip = (
    impressionEvent: AnalyticsContextValue["impressionEvent"],
    data: ContextData,
): void => {
    impressionEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: IMPRESSION_ACTIONS.IMPRESSION_MORE_OFFERS_STRIP,
        context: JSON.stringify(data),
    });
};

export const clickMoreOffersStripEvent = (clickEvent: AnalyticsContextValue["clickEvent"]): void => {
    clickEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: CLICK_ACTIONS.CLICK_MORE_OFFERS_STRIP,
    });
};
